import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 13 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.39607 6.81519C2.78849 6.81519 3.1066 7.12177 3.1066 7.49997V8.90214C3.1066 8.96268 3.13155 9.02074 3.17597 9.06355C3.22039 9.10635 3.28063 9.1304 3.34344 9.1304H9.02765C9.09047 9.1304 9.15071 9.10635 9.19512 9.06355C9.23954 9.02074 9.26449 8.96268 9.26449 8.90214V7.49997C9.26449 7.12177 9.58261 6.81519 9.97502 6.81519C10.3674 6.81519 10.6855 7.12177 10.6855 7.49997V8.90214C10.6855 9.32591 10.5109 9.73232 10.2 10.032C9.88905 10.3316 9.46735 10.5 9.02765 10.5H3.34344C2.90374 10.5 2.48205 10.3316 2.17113 10.032C1.86022 9.73232 1.68555 9.32591 1.68555 8.90214V7.49997C1.68555 7.12177 2.00366 6.81519 2.39607 6.81519Z",
			fill: "#2882DE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.7077 7.85375C6.43022 8.12118 5.98034 8.12118 5.70287 7.85375L3.80813 6.02767C3.53065 5.76024 3.53065 5.32666 3.80813 5.05924C4.08561 4.79181 4.53549 4.79181 4.81297 5.05924L6.20528 6.40111L7.5976 5.05924C7.87508 4.79181 8.32496 4.79181 8.60244 5.05924C8.87992 5.32666 8.87992 5.76024 8.60244 6.02767L6.7077 7.85375Z",
			fill: "#2882DE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.20528 8.05432C5.81287 8.05432 5.49476 7.74773 5.49476 7.36954L5.49476 1.43476C5.49476 1.05656 5.81287 0.749974 6.20528 0.749974C6.5977 0.749974 6.91581 1.05656 6.91581 1.43476L6.91581 7.36954C6.91581 7.74773 6.5977 8.05432 6.20528 8.05432Z",
			fill: "#2882DE"
		})
	]
});
export default SvgDownload;
